module.exports = __webpack_public_path__ + "assets/ziyuan_12.ea639202.svg";